import { write } from '@/lib/firebase';
import { migrateSavings } from '../utils/savingsMigration';

const budgetPath = (householdId) => `households/${householdId}/budget`;

function newId() {
  return 'goal-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
}

export const savingsService = {
  async createGoal(householdId, data, fields) {
    const savings = migrateSavings(data.savings);
    const id = newId();
    const goal = {
      id,
      name: fields.name,
      icon: fields.icon || '🎯',
      color: fields.color || '#3b82f6',
      target: Number(fields.target) || 0,
      saved: Number(fields.saved) || 0,
      monthlyTarget: Number(fields.monthlyTarget) || 0,
      targetDate: fields.targetDate || null,
      priority: Object.keys(savings.goals).length,
      createdAt: new Date().toISOString(),
    };
    const updated = { ...savings, goals: { ...savings.goals, [id]: goal } };
    await write(budgetPath(householdId), { ...data, savings: updated });
    return goal;
  },

  async updateGoal(householdId, data, goalId, patch) {
    const savings = migrateSavings(data.savings);
    const existing = savings.goals[goalId];
    if (!existing) throw new Error(`Goal ${goalId} not found`);
    const updated = {
      ...savings,
      goals: { ...savings.goals, [goalId]: { ...existing, ...patch } },
    };
    await write(budgetPath(householdId), { ...data, savings: updated });
  },

  async deleteGoal(householdId, data, goalId) {
    const savings = migrateSavings(data.savings);
    const goals = { ...savings.goals };
    delete goals[goalId];
    await write(budgetPath(householdId), { ...data, savings: { ...savings, goals } });
  },

  // Adds amount to saved + creates a transaction in "Home Deposit Savings" category (or first Savings & Goals sub-cat)
  async contribute(householdId, data, goalId, amount, txnDescription) {
    const savings = migrateSavings(data.savings);
    const goal = savings.goals[goalId];
    if (!goal) throw new Error(`Goal ${goalId} not found`);

    const newSaved = (Number(goal.saved) || 0) + Number(amount);
    const updatedSavings = {
      ...savings,
      goals: {
        ...savings.goals,
        [goalId]: { ...goal, saved: newSaved },
      },
    };

    const txn = {
      id: 'txn-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6),
      date: new Date().toISOString().slice(0, 10),
      description: txnDescription || `Contribution: ${goal.name}`,
      category: 'Home Deposit Savings',
      amount: Number(amount),
      type: 'expense',
      who: '',
      paymentMethod: 'Bank Transfer',
      notes: `Savings goal: ${goal.name}`,
      savingsGoalId: goalId,
    };

    const txns = [...(data.txns || []), txn];
    await write(budgetPath(householdId), { ...data, savings: updatedSavings, txns });
    return txn;
  },
};
